import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { cameraPropSelector } from 'selectors/components'
import { computeAngle, computeDistanceToBlindSpot } from '../helpers'

const distanceToBlindSpotSelector = createSelector(
  cameraPropSelector('tilt'),
  cameraPropSelector('fovMode'),
  cameraPropSelector('verticalAngleOfView'),
  cameraPropSelector('horizontalAngleOfView'),
  cameraPropSelector('cameraHeight'),
  (tilt, fovMode, verticalAngleOfView, horizontalAngleOfView, cameraHeight) =>
    computeDistanceToBlindSpot(
      tilt,
      computeAngle(
        fovMode,
        verticalAngleOfView,
        horizontalAngleOfView
      ),
      cameraHeight
    )
)

const mapStateToProps = state => {
  return {
    distanceToBlindSpot: distanceToBlindSpotSelector(state),
    isImperial: state.ui.isImperial
  }
}

class DistanceToBlindSpotDisplay extends React.Component {
  render() {
    const { distanceToBlindSpot, isImperial } = this.props
    return (
      <div>
        <strong>Distance to blind spot:</strong> {distanceToBlindSpot < 0 ? 'Blind spot not available' : `${Math.round(distanceToBlindSpot)}${isImperial ? 'ft' : 'm'}`}
      </div>
    )
  }
}

export default connect(mapStateToProps)(DistanceToBlindSpotDisplay)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/DistanceToBlindSpotDisplay/index.js